import axios from "axios";
import config from "../config";

/**
 * Fetch a specific appSettings value.
 * 1️⃣ Try from localStorage
 * 2️⃣ If not available, fetch from API and store in localStorage
 *
 * @param {string} key - The appSettings key you want (e.g. "onlyTowardsDestination")
 * @param {*} defaultValue - Value to return if key not found
 * @returns {*} value from settings or defaultValue
 */
export const getvalueFromLocalstorage = async (key, defaultValue = null) => {
  try {
    // STEP 1: Try to get from localStorage
    const appSettingsString = localStorage.getItem("appSettings");
    if (appSettingsString) {
      const appSettings = JSON.parse(appSettingsString);
      if (appSettings.hasOwnProperty(key)) {
        return appSettings[key];
      }
    }

    // STEP 2: Try to get from API
    let organizationId;
    const urlParams = new URLSearchParams(window.location.search);
    organizationId = urlParams.get("org");

    if (!organizationId) {
      const pathParts = window.location.pathname.split("/");
      const orgFromPath = pathParts[pathParts.length - 1];
      if (orgFromPath && !isNaN(orgFromPath)) {
        organizationId = orgFromPath;
      }
    }

    if (!organizationId) {
      console.warn("Organization ID not found in URL, using default value");
      return defaultValue;
    }

    const response = await axios.get(`${config.baseURL}/appSettings/organization`, {
      params: { organizationId },
    });

    if (response.data) {
      // Cache in localStorage for future use
      localStorage.setItem("appSettings", JSON.stringify(response.data));

      if (response.data.hasOwnProperty(key)) {
        return response.data[key];
      }
    }

    console.warn(`AppSetting key '${key}' not found in API response`);
    return defaultValue;

  } catch (error) {
    console.error("Error getting appSetting value:", error);
    return defaultValue;
  }
};
